import React from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";

import Button from "./UIElements/Button";

const ColorElement = (props) => {
  return (
    <div>
      <CopyToClipboard text={props.text} onCopy={() => props.onClick()}>
        <div>
          <Button className={props.className} text={props.text}>
            {props.text}
          </Button>
        </div>
      </CopyToClipboard>
    </div>
  );
};

export default ColorElement;
